{
  "fi-FI": {
    "model": {
      "profile": {
        "id": "Käyttäjätunnus",
        "userName": "Käyttäjänimi",
        "email": "Sähköpostiosoite",
        "emailConfirmed": "Sähköpostiosoite vahvistettu",
        "phoneNumber": "Puhelinnumero",
        "phoneNumberConfirmed": "Puhelinnumero vahvistettu",
        "twoFactorEnabled": "Kaksivaiheinen tunnistautuminen on käytössä.",
        "lockoutEnd": "Lukituksen päättymisajankohta",
        "lockoutEnabled": "Lukitustoiminto käytössä",
        "accessFailedCount": "Epäonnistuneiden kirjautumisyritysten määrä",
        "firstName": "Etunimi",
        "lastName": "Sukunimi",
        "picture": "Profiilikuvaksi valittu kuva",
        "organisationName": "Organisaatio",
        "name": "Nimi",
        "roles": "Roolit"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Vahvistettu"
      },
      "action": {
        "resetPassword.tooltip": "Lähetä salasanan palautusohjeet käyttäjälle sähköpostitse."
      },
      "message": {
        "resetPassword.success": "Käyttäjälle on lähetetty sähköposti, joka sisältää ohjeet salasanan nollaukseen."
      }
    }
  }
}